'use strict';

+function ($) {

  basecoat.toast = function (content, type) {
    var $toast = $('<div class="toast-alert fade">' + content + '</div>');
    type = type || 'default';
    $toast.addClass('toast-' + type);

    $toast.on('show.bc.toast', function (e, duration) {
      duration = duration || 5000;
      // hide any existing toasts
      $('.toast-alert').trigger('hide');
      var $toast = $(this);
      $('body').append($toast);
      $toast[0].offsetWidth; // forces reflow before applying fade in effect
      $toast.addClass('in');
      // auto hide toast
      window.setTimeout(function () {
        $toast.trigger('hide');
      }, duration);
    });

    $toast.on('hide.bc.toast', function () {
      var $toast = $(this).removeClass('in');
      window.setTimeout(function () {
        $toast.remove();
      }, 1000);
    });

    return $toast;
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/toast.js
// module id = 20
// module chunks = 0